import * as React from "react";
import {
  container,
  benfitsTitle,
  benfitsSubTitle,
  description,
} from "./MembershipBenefits.module.scss";

export const Container: React.FC<any> = (props) => {
  return <div className={container}>{props.children}</div>;
};
export const Title: React.FC<any> = (props) => {
  return <h2 className={benfitsTitle}>{props.children}</h2>;
};
export const SubTitle: React.FC<any> = (props) => {
  return <div className={benfitsSubTitle}>{props.children}</div>;
};
export const Description: React.FC<any> = (props) => {
  return (
    <p
      className={description}
      dangerouslySetInnerHTML={{ __html: props.children }}
    />
  );
};
export const LinksContainer: React.FC<any> = (props) => {
  return <div className={props.className}>{props.children}</div>;
};
